import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'

import Details from '../components/Details'

@inject('program', 'message')
@observer
class DetailsContainer extends Component {

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    message: PropTypes.object.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    program: PropTypes.object.isRequired,
    router: PropTypes.shape({
      goBack: PropTypes.func.isRequired,
    }).isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      messageError: null
    }
  }

  componentWillMount() {
    const { params: { id }, program } = this.props
    program.openById(id * 1)
  }

  @autobind
  handleClose() {
    this.props.router.goBack()
  }

  @autobind
  handleSendMessage({ target: { value } }) {
    this.props.message.send(value)
      .then(() => {
        this.setState({
          messageError: null,
        })
        this.handleClose()
      })
      .catch((ex) => {
        this.setState({
          messageError: JSON.stringify(ex.errors)
        })
      })
  }

  render() {
    const {
      program,
      program: { current },
      params: { id }
    } = this.props

    if (program.loading) {
      return <div>Program wird geladen</div>
    }

    if (!current || current.id !== id * 1) {
      return <div>Program nicht gefunden!</div>
    }

    return (
      <Details
        current={current}
        onSendMessage={this.handleSendMessage}
        messageError={this.state.messageError}
      />
    )
  }
}

const DetailsContainerWithRouter = withRouter(DetailsContainer)

export { DetailsContainerWithRouter as default }



// WEBPACK FOOTER //
// ./src/program/containers/Details.js